import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import ReviewCard from "./ReviewCard";
import { toCamelCase } from "utils/Utils";

const fieldStyle = {
  marginBottom: 18,
};

const labelStyle = {
  fontSize: 13,
  color: "#7C8798",
  marginBottom: 4,
};

const valueStyle = {
  fontSize: 15,
  fontWeight: 500,
  color: "#1F2937",
};

const imageStyle = {
  width: 150,
  height: 150,
  borderRadius: 10,
  border: "1px solid #E5E7EB",
  objectFit: "cover",
};

const Item = ({ label, value }) => (
  value && <Grid item xs={12} sm={6} md={3}>
    <div style={fieldStyle}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>{value || "NA"}</div>
    </div>
  </Grid>
);

const PersonalInfoReview = ({
  generalDetails,
  documentDetails,
  userLeadIdDetails,
  photoDetails,
}) => {
  return (
    <ReviewCard title="General Details">

      <Grid container spacing={4}>

       {documentDetails?.customerPhotoLink &&  <Grid item xs={12} md={2}>
          <div style={labelStyle}>Customer Photo</div>

          <img
            src={documentDetails?.customerPhotoLink}
            alt=""
            style={imageStyle}
          />
        </Grid>
}
        <Grid item xs={12} md={8}>
          <Grid container>

            {photoDetails?.confidence && <Item
              label="Photo Match"
              value={`${photoDetails?.confidence || 0}%`}
            />}

            <Item
              label="Name"
              value={userLeadIdDetails?.customer_name}
            />

            <Item
              label="Occupation"
              value={generalDetails?.occupation}
            />

            <Item
              label="Email"
              value={generalDetails?.email}
            />

            <Item
              label="Marital Status"
              value={toCamelCase(generalDetails?.maritalStatus)}
            />

            <Item
              label="Education"
              value={generalDetails?.education}
            />

            <Item
              label="Credit Score"
              value={generalDetails?.creditScore}
            />

          </Grid>
        </Grid>

      </Grid>

    </ReviewCard>
  );
};

PersonalInfoReview.propTypes = {
  generalDetails: PropTypes.object,
  documentDetails: PropTypes.object,
  userLeadIdDetails: PropTypes.object,
  photoDetails: PropTypes.object,
};

export default PersonalInfoReview;